import Vue from 'vue'

import { findAll} from '@/views/charge/adminChargeService'

const state = {
  adminCharges: []
}

const getters = {
  adminCharges: (state) => state.adminCharges
}

const actions = {
  async fetchAdminCharges({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await findAll(params)
      const { result, total } = await data

      commit('setAdminCharges', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
}

const mutations = {
  setAdminCharges: (state, adminCharges) => {
    state.adminCharges = adminCharges
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
